import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pl-4 align-center" }
const _hoisted_2 = { class: "pl-4 align-center" }
const _hoisted_3 = { class: "pl-4" }
const _hoisted_4 = { class: "pl-4" }

import { reactive, watch, ref } from 'vue';
import { Core as YubinBangoCore } from 'yubinbango-core2';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressForm',
  props: {
    zipCode: {},
    province: {},
    address1: {},
    address2: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ['inputValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const zip1 = ref('');
const zip2 = ref('');
const provinceValue = ref('');
const address1Value = ref('');
const address2Value = ref('');
const data = reactive({
  zip1: '',
  zip2: '',
  province: '',
  address1: '',
  address2: '',
});

const unwatchZipcode = watch(
  () => props.zipCode,
  (propsZipCode) => {
    const splitZipcode = propsZipCode?.split('-') ?? ['', ''];
    zip1.value = splitZipcode[0];
    zip2.value = splitZipcode[1];
    unwatchZipcode();
  }
);
const unwatchProvince = watch(
  () => props.province,
  (propsProvince) => {
    provinceValue.value = propsProvince;
    unwatchProvince();
  }
);
const unwatchAddress1 = watch(
  () => props.address1,
  (propsAddress1) => {
    address1Value.value = propsAddress1;
    unwatchAddress1();
  }
);
const unwatchAddress2 = watch(
  () => props.address2,
  (propsAddress2) => {
    address2Value.value = propsAddress2;
    unwatchAddress2();
  }
);

function autoCompleteAddress() {
  const zipCodeValue = zip1.value + zip2.value;
  if (!zipCodeValue.match(/^\d{3}-?\d{4}$/)) {
    provinceValue.value = '';
    address1Value.value = '';
    address2Value.value = '';
  }
  if (zipCodeValue.length == 7) {
    new YubinBangoCore(zipCodeValue, (addr: any) => {
      provinceValue.value = addr.region;
      address1Value.value = addr.locality + addr.street;
    });
  }
}

watch(zip1, () => {
  data.zip1 = zip1.value;
  emit('inputValue', data);
});
watch(zip2, () => {
  data.zip2 = zip2.value;
  emit('inputValue', data);
});
watch(provinceValue, () => {
  data.province = provinceValue.value;
  emit('inputValue', data);
});
watch(address1Value, () => {
  data.address1 = address1Value.value;
  emit('inputValue', data);
});
watch(address2Value, () => {
  data.address2 = address2Value.value;
  emit('inputValue', data);
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.address.postCode')), 1)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: zip1.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((zip1).value = $event)),
              maxlength: "3",
              onKeyup: autoCompleteAddress,
              "error-messages": __props.errors?.zipcode
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"height":"50px","line-height":"50px"} }, " - ", -1)),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: zip2.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((zip2).value = $event)),
              maxlength: "4",
              onKeyup: autoCompleteAddress,
              error: __props.errors?.zipcode?.length ? true : false
            }, null, 8, ["modelValue", "error"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.address.prefectures')), 1)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: provinceValue.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((provinceValue).value = $event)),
              maxlength: "255",
              "error-messages": __props.errors?.province
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.address.address1')), 1)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 10 : 9
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: address1Value.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((address1Value).value = $event)),
              maxlength: "255",
              "error-messages": __props.errors?.address1
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.address.address2')), 1)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 10 : 9
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: address2Value.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((address2Value).value = $event)),
              maxlength: "255",
              "error-messages": __props.errors?.address2
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    })
  ], 64))
}
}

})